import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { BenchmarkPositionAuditImpl } from "../model/impl/BenchmarkPositionAuditImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class BenchmarkPositionAuditImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: BenchmarkPositionAuditImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.auditId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(1),
        false,
        encodable.auditId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.userId != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(2),
        false,
        encodable.userId,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.bmTimeCode != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(3),
        true,
        encodable.bmTimeCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.orderAction != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(4),
        false,
        encodable.orderAction,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.orderState != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(5),
        false,
        encodable.orderState,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.actionTime != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(6),
        false,
        encodable.actionTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.comments != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(7),
        false,
        encodable.comments,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.userName != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(8),
        false,
        encodable.userName,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.userCd != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(9),
        false,
        encodable.userCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkPositionAuditImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,BenchmarkPositionAuditImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.Long"],
    [3, "com.bcdfx.model.BMTimeCode"],
    [4, "java.lang.String"],
    [5, "com.bcdfx.api.model.OrderState"],
    [6, "java.lang.Long"],
    [7, "java.lang.String"],
    [8, "java.lang.String"],
    [9, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: BenchmarkPositionAuditImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.auditId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.userId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.BMTimeCode = this.baseEncoder.readObject(
            true,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.bmTimeCode = <CubiqTS.BMTimeCode>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.orderAction = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.OrderState = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.orderState = <CubiqTS.OrderState>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.actionTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.comments = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.userName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.userCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkPositionAuditImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,BenchmarkPositionAuditImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return BenchmarkPositionAuditImplEncoder.fidTypeMap.has(fid);
  }
}
